<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span id="dlgCategoryTitle" class="title dialog-title">{{ title }}</span>
      <button
        id="dlgCategoryClose"
        mat-icon-button
        class="mat-icon-button white-fg"
        (click)="dialogRef.close()"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
    <form class="addDialog" [formGroup]="wizard" fxLayout="column" fxFlex>
      <div class="pb-24">
        {{ intro }}
      </div>
      <div
        formArrayName="subjectTypes"
        fxLayout="column"
        fxLayoutAlign="space-between stretch"
      >
        <div
          *ngFor="
            let subjectType of wizard.controls.subjectTypes['controls'];
            let i = index
          "
          fxFlex="1 0 auto"
        >
          <mat-form-field>
            <mat-label>{{subjectTypes[i].name}}</mat-label>
            <mat-select
              class="form-control py-8"
              [formControlName]="i"
              name="subjectTypes[i].name"
              required
            >
              <mat-option
                *ngFor="let item of subjectTypes[i].subjects"
                [value]="item.id"
              >
                {{ item.relationship }} - {{ item.name }}
              </mat-option>
            </mat-select>
            <validation-errors
              [control]="subjectTypes[i].name"
            ></validation-errors>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div
    mat-dialog-actions
    class="m-0 p-24"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div>
      <button
        id="btnOk"
        mat-raised-button
        type="submit"
        [mat-dialog-close]="1"
        (click)="confirmSubmit()"
        class="mat-accent"
        aria-label="Create Documents"
      >
        {{ this.confirm }}
      </button>
    </div>
  </div>
</div>
